import SuccessPopup from '@/components/Popups/SuccessPopup';
import { SecondaryButton } from '@/components/buttons/SecondaryButton';
import { PrimaryButton } from '@/components/buttons/PrimaryButton';
import CancelPopup from '@/components/Popups/CancelPopup';
import { MaintenanceOrder } from '@/types/maintenance';
import { useNavigate } from 'react-router-dom';

interface Props {
    maintenanceOrder?: MaintenanceOrder | null;
    showSuccessPopup: boolean;
    setShowSuccessPopup: (value: boolean) => void;
    showCancelPopup: boolean;
    setShowCancelPopup: (value: boolean) => void;
    loading: boolean;
    onClose: () => void; // Add onClose prop
    onAddAnother: () => void;
    onSubmit?: () => void; // Add onSubmit prop
}
export default function Submission({
    maintenanceOrder,
    setShowCancelPopup,
    setShowSuccessPopup,
    showCancelPopup,
    showSuccessPopup,
    loading,
    onClose,
    onAddAnother,
    onSubmit,
}: Props) {
    const navigate = useNavigate();

    const handleAddAnother = () => {
        setShowSuccessPopup(false);
        onAddAnother();
    };
    return (
        <>
            <div className="flex flex-row mt-8 w-full">

                <SecondaryButton
                    type="button"
                    className="w-full xl:py-3 border bordr-[#E8EFF6] xl:font-semibold"
                    onClick={() => setShowCancelPopup(true)}
                >
                    الغاء
                </SecondaryButton>

                <PrimaryButton
                    type="button"
                    className="w-full xl:py-3 xl:font-semibold ms-6"
                    disabled={loading}
                    onClick={onSubmit}
                >
                    {loading ? 'جاري التحميل...' : 'اضافه'}
                </PrimaryButton>

            </div>

            <CancelPopup
                open={showCancelPopup}
                onClickButton1={() => {
                    setShowCancelPopup(false);
                }}
                onClickButton2={() => {
                    // navigate('/services');
                    setShowCancelPopup(false);
                    onClose(); // Close the modal
                    // window.location.reload();
                }}
                text1="تم اضافه الخدمه"
                text2="أنت على وشك إلغاء عملية اضافه الخدمه دون إكمال البيانات المطلوبة. سيتم تجاهل جميع البيانات المدخلة، هل أنت متأكد؟"
                textButton1="إكمال اضافه الخدمه"
                textButton2="إلغاء اضافه الخدمه"
            />
            <SuccessPopup
                text1='تم اضافه الخدمه بنجاح'
                text2='تم اضافه الخدمه بنجاح.'
                textButton1="العودة لقائمة الخدمات"
                textButton2='اضافه خدمه اخرى'
                open={showSuccessPopup}
                onAddAnother={handleAddAnother}
                onReturnToList={() => {
                    // navigate('/services');
                    setShowSuccessPopup(false);
                    onClose(); // Close the modal
                    window.location.reload();
                }}
            />
        </>
    );
}
